export default "__VITE_ASSET__CKkyyMdO__"